import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChange, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomModalComponent, FieldConfig } from 'hig-ng-lib';
import { TreoDatepickerComponent } from '../../../../app/components/treo-datepicker/treo-datepicker.component';
import { AppConfig } from '../../../../config/app-config';
import {
    CLAIM_MENU,
    PAYMENT_AND_RECOVERY,
    PRINT_CLAIM_DETAILS_TITLE,
    PRINT_ERROR,
    PRINT_ERROR_MESSAGE,
    PRINT_FINANCIAL_CATEGORIES,
    PRINT_TRANSACTION_AMOUNT_SELECT,
    PRINT_TRASACTION_DATE_SELECT
} from '../../../../treo.properties';
import { DatepickerComponent } from '../../../components/datepicker/datepicker.component';
import { isNilOrEmpty } from '../../../shared/utils';

import moment from 'moment';
import { LoaderService } from '../../../core/services/loading.service';
import { ClaimsService } from '../claims.service';

@Component({
    selector: 'app-print-modal',
    templateUrl: './print-modal.component.html',
    styleUrls: ['./print-modal.component.scss'],
    standalone: false
})
export class PrintModalComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    @Input() showPrint: boolean = false;
    @Input() data;
    @Input() showCustomData;

    claimListLength: any;
    printClaimDetailsTitle: any;
    printModalForm: UntypedFormGroup;
    claimNotesCheck: FieldConfig;
    claimNoteDateForm: UntypedFormGroup;
    isVisible = false;
    isRefineSectionVisible = false;
    isFormVisible = false;
    isNoteDataVisible = false;
    noteDateSelect: Array<object>;
    transactionAmountSelect: Array<Object>;
    paymentAndRecovery: Array<object>;
    financialCategories: Array<object>;
    financialMatrixFlag: boolean = false;
    financialTransactionsFlag: boolean = false;
    claimNotesFlag: boolean = false;
    financialDisableFlag: boolean = true;
    financialTransFlag: boolean = true;
    claimNotesDisableFlag: boolean = true;
    showPrintError: boolean = false;
    showPrintErrorMsg: boolean = false;
    showOperatorError: boolean = false;
    showFinal: boolean = false;
    printError: any;
    transactionDateSelectConfig = AppConfig.transactionDateSelectConfig;
    claimNotesDateSelectConfig = AppConfig.claimNotesDateSelectConfig;
    financialCategoriesConfig = AppConfig.financialCategoriesConfig;
    transactionAmountSelectConfig = AppConfig.transactionAmountSelectConfig;
    showTransactionToDatePicker: boolean = false;
    showClaimNotesDatePicker: boolean = false;
    transactionDatePickerField = AppConfig.transactionDatePickerField;
    transactionToDatePicker = AppConfig.transactionToDatePicker;
    claimNotesToDatePickerField = AppConfig.claimNotesToDatePickerField;
    claimNotesDatePickerField = AppConfig.claimNotesDatePickerField;
    printFinancialMatrixDatePicker = AppConfig.printFinancialMatrixDatePicker;
    valuationDate = new Date(
        JSON.parse(this.loaderService.getItem('valuationDate'))?.lastDefaultValuationDate?.slice(0, 10)
    );
    formattedDate = moment(this.valuationDate).utc().format('YYYY-MM-DD');
    showBothAmountError: boolean = false;
    finacialCategories: any[] = [];
    activityTypes: any[] = [];

    customFilterLabels: any = {
        TRANSACTION_DATE_TYPE_ERROR_MSG: {
            ENTER_FROM_DATE: 'Please enter the from date.',
            ENTER_TO_DATE: 'Please enter the to date.',
            ENTER_TWO_DATES: 'Please enter both dates.'
        }
    };
    fromDate: any;
    toDate: any;
    selectedDate: Date;
    selectedEndDate;

    @Output() printClicked = new EventEmitter<any>();

    @ViewChild('printModal', { static: true }) printModalRef: CustomModalComponent;
    @ViewChild('datepicker') datepicker: TreoDatepickerComponent;
    @ViewChild('transactionDatePickerTemplate') transactionDatePickerTemplate: DatepickerComponent;
    @ViewChild('transactionToDatePickerTemplate') transactionToDatePickerTemplate: DatepickerComponent;
    @ViewChild('ClaimNotesDatePickerTemplate') ClaimNotesDatePickerTemplate: DatepickerComponent;
    @ViewChild('ClaimNotesToDatePickerTemplate') ClaimNotesToDatePickerTemplate: DatepickerComponent;
    @ViewChild('datepickerOne') datepickerOne: TreoDatepickerComponent;
    @ViewChild('datepickerTwo') datepickerTwo: TreoDatepickerComponent;
    @ViewChild('datepickerThree') datepickerThree: TreoDatepickerComponent;
    @ViewChild('datepickerFour') datepickerFour: TreoDatepickerComponent;

    messageFieldConfig: any = {
        name: 'printErrorMsg',
        showField: true
    };
    printModelLabel = CLAIM_MENU;
    transactionAmtField: FieldConfig = {
        value: '',
        type: 'input',
        subType: 'currency',
        showField: true,
        name: 'transactionAmtField',
        id: '',
        className: '',
        isTealiumAllowed: false,
        placeHolder: '',
        label: ''
    };
    transactionAmtEndField: FieldConfig = {
        value: '',
        type: 'input',
        subType: 'currency',
        showField: true,
        name: 'transactionAmtEndField',
        id: '',
        className: '',
        isTealiumAllowed: false,
        placeHolder: '',
        label: ''
    };
    financialActivitySelectConfig: FieldConfig;

    public JSON = JSON;

    treoDatePickerTest($event) {
        this.datepicker.setMessage($event.detail.valueAsDate);
    }

    constructor(private fb: UntypedFormBuilder, private claimService: ClaimsService, private loaderService: LoaderService) { }

    ngOnInit() {
        this.printModalForm = this.fb.group({
            claimDemographicsCheck: [false],
            customDemoCheck: [false],
            financialMatrixCheck: [false],
            financialValuationDate: [''],
            financialTransactionsCheck: [false],
            financialTransRadio: [{ value: '', disabled: true }],
            claimNotesCheck: [false],
            claimNotesRadio: [{ value: '', disabled: true }],
            transactionDateSelect: [''],
            transactionDate: [''],
            transactionToDate: [''],
            transactionAmountSelect: [''],
            transactionAmtField: [''],
            transactionAmtEndField: [''],
            financialCategories: [''],
            finacialActivityType: [''],
            noteDateSelect: [''],
            noteDate: [''],
            noteToDate: ['']
        });
        this.printClaimDetailsTitle = PRINT_CLAIM_DETAILS_TITLE;

        this.noteDateSelect = PRINT_TRASACTION_DATE_SELECT;
        this.transactionAmountSelect = PRINT_TRANSACTION_AMOUNT_SELECT;
        this.financialCategories = PRINT_FINANCIAL_CATEGORIES;
        this.paymentAndRecovery = PAYMENT_AND_RECOVERY;

        this.printModalForm.get('financialMatrixCheck')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((checked: boolean) => {
            if (checked) {
                this.datepicker.disabledDatepicker(false);
                this.printModalForm.controls['financialValuationDate'].enable();

                if (this.formattedDate) {
                    this.datepicker.disabledDatepicker(false);
                    this.datepicker.date = this.formattedDate;
                    this.printModalForm.get('financialValuationDate')?.setValue(this.formattedDate);
                }
            } else {
                this.datepicker.resetDate();
                this.datepicker.disabledDatepicker(true);
            }
        });

        // Subscribe to claim notes radio changes
        this.printModalForm.get('claimNotesRadio')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value: string) => {
            if (value === 'S') {
                this.isNoteDataVisible = true;
            } else if (value === 'A') {
                this.isNoteDataVisible = false;
                this.printModalForm.patchValue({
                    noteDateSelect: '',
                    noteDate: '',
                    noteToDate: ''
                });
                this.showClaimNotesDatePicker = false;
            } else {
                this.isNoteDataVisible = false;
            }
        });

        // Subscribe to financial transactions radio changes
        this.printModalForm.get('financialTransRadio')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value: string) => {
            if (value === 'S') {
                this.isRefineSectionVisible = true;
                this.printModalForm.patchValue({
                    financialCategories: ['Indemnity', 'Medical', 'Expense'],
                    finacialActivityType: 'Payment and Recovery'
                });
            } else if (value === 'A') {
                this.isRefineSectionVisible = false;
                this.printModalForm.patchValue({
                    transactionDateSelect: '',
                    transactionDate: '',
                    transactionToDate: '',
                    transactionAmountSelect: '',
                    transactionAmtField: '',
                    transactionAmtEndField: '',
                    financialCategories: '',
                    finacialActivityType: ''
                });
                this.showTransactionToDatePicker = false;
                this.showFinal = false;
            }
        });

        this.loadDropdownData();
        setTimeout(() => {
            this.financialActivitySelectConfig = {
                type: 'select',
                label: '',
                name: 'finacialActivityType',
                showField: true,
                placeHolder: '',
                options: this.activityTypes,
                id: 'print-modal-transactionDate-select'
            };
        }, 1000);
    }

    ngOnChanges(changes: SimpleChange) {
        if (this.showPrint) {
            this.showModal(this.data);
        } else {
            this.hideModal();
        }
    }

    onFinancialMatrixCheck(event) {
        this.financialMatrixFlag = event.target.checked;
        if (!this.financialMatrixFlag) {
            this.financialDisableFlag = true;
        } else {
            this.financialDisableFlag = false;
            this.showPrintError = false;
        }
    }

    onFinancialTransCheck(event) {
        this.financialTransactionsFlag = event.target.checked;
        if (!this.financialTransactionsFlag) {
            this.printModalForm.controls['financialTransRadio'].disable();
            this.financialTransFlag = true;
            this.isRefineSectionVisible = false;
            this.printModalForm.patchValue({
                financialTransRadio: '',
                transactionDateSelect: '',
                transactionDate: '',
                transactionToDate: '',
                transactionAmountSelect: '',
                transactionAmtField: '',
                transactionAmtEndField: '',
                financialCategories: '',
                finacialActivityType: ''
            });
        } else {
            this.printModalForm.controls['financialTransRadio'].enable();
            this.showPrintError = false;
            this.financialTransFlag = false;
            this.isVisible = true;
        }
    }

    onClaimNotesCheck(event) {
        this.claimNotesFlag = event.target.checked;
        if (!this.claimNotesFlag) {
            this.printModalForm.controls['claimNotesRadio'].disable();
            this.claimNotesDisableFlag = true;
            this.isNoteDataVisible = false;
            this.showClaimNotesDatePicker = false;
            this.printModalForm.patchValue({
                claimNotesRadio: '',
                noteDateSelect: '',
                noteDate: '',
                noteToDate: ''
            });
        } else {
            this.printModalForm.controls['claimNotesRadio'].enable();
            this.showPrintError = false;
            this.claimNotesDisableFlag = false;
            this.isVisible = true;
        }
    }

    options: any = {
        required: true,
        maxDate: new Date(JSON.parse(this.loaderService.getItem('valuationDate'))?.lastDefaultValuationDate?.slice(0, 10)),
        minDate: new Date(JSON.parse(this.loaderService.getItem('valuationDate'))?.firstValuationDate?.slice(0, 10))
    };

    handleDateChange(event: any) {
        const selectedNewDate = event?.detail?.valueAsDate;
        if (selectedNewDate) {
            const newDate = moment(selectedNewDate).utc().format('YYYY-MM-DD');
            this.printModalForm.get('financialValuationDate')?.setValue(newDate);
        }
    }

    handleBetweenTransactionDateType() {
        const selectedDateType = this.printModalForm.get('transactionDateSelect').value;
        this.showTransactionToDatePicker = selectedDateType === 'Between';

        if (selectedDateType === 'Between') {
            if (
                isNilOrEmpty(this.printModalForm.controls['transactionDate'].value) &&
                this.transactionDatePickerField.isTouched
            ) {
                this.transactionDatePickerTemplate.updateCustomValidation(
                    'set',
                    this.customFilterLabels.TRANSACTION_DATE_TYPE_ERROR_MSG.ENTER_FROM_DATE
                );
            }

            if (
                isNilOrEmpty(this.printModalForm.controls['transactionToDate'].value) &&
                this.transactionToDatePicker.isTouched
            ) {
                this.transactionToDatePickerTemplate.updateCustomValidation(
                    'set',
                    this.customFilterLabels.TRANSACTION_DATE_TYPE_ERROR_MSG.ENTER_TO_DATE
                );
            }

            if (
                (this.transactionDatePickerField.hasValidationError &&
                    this.transactionToDatePicker.isTouched &&
                    isNilOrEmpty(this.printModalForm.controls['transactionToDate'].value)) ||
                (this.transactionDatePickerField.hasValidationError && this.transactionToDatePicker.hasValidationError)
            ) {
                this.transactionDatePickerTemplate.updateCustomValidation(
                    'set',
                    this.customFilterLabels.TRANSACTION_DATE_TYPE_ERROR_MSG.ENTER_TWO_DATES
                );
                this.transactionToDatePickerTemplate.updateCustomValidation('set', '');
            }

            if (!isNilOrEmpty(this.fromDate) && !isNilOrEmpty(this.toDate)) this.compareTransactionDates();
        }
    }

    handleBetweenClaimNotesDateType() {
        const selectedDateType = this.printModalForm.get('noteDateSelect').value;
        this.showClaimNotesDatePicker = selectedDateType === 'Between';

        if (selectedDateType === 'Between') {
            if (
                isNilOrEmpty(this.printModalForm.controls['noteDate'].value) &&
                this.claimNotesDatePickerField.isTouched
            ) {
                this.ClaimNotesDatePickerTemplate.updateCustomValidation(
                    'set',
                    this.customFilterLabels.TRANSACTION_DATE_TYPE_ERROR_MSG.ENTER_FROM_DATE
                );
            }

            if (
                isNilOrEmpty(this.printModalForm.controls['noteToDate'].value) &&
                this.claimNotesToDatePickerField.isTouched
            ) {
                this.ClaimNotesToDatePickerTemplate.updateCustomValidation(
                    'set',
                    this.customFilterLabels.TRANSACTION_DATE_TYPE_ERROR_MSG.ENTER_TO_DATE
                );
            }

            if (
                (this.claimNotesDatePickerField.hasValidationError &&
                    this.claimNotesToDatePickerField.isTouched &&
                    isNilOrEmpty(this.printModalForm.controls['noteToDate'].value)) ||
                (this.claimNotesDatePickerField.hasValidationError &&
                    this.claimNotesToDatePickerField.hasValidationError)
            ) {
                this.ClaimNotesDatePickerTemplate.updateCustomValidation(
                    'set',
                    this.customFilterLabels.TRANSACTION_DATE_TYPE_ERROR_MSG.ENTER_TWO_DATES
                );
                this.ClaimNotesToDatePickerTemplate.updateCustomValidation('set', '');
            }

            if (!isNilOrEmpty(this.fromDate) && !isNilOrEmpty(this.toDate)) this.compareClaimNotesDates();
        }
    }

    compareTransactionDates() {
        if (
            this.printModalForm.controls['transactionDateSelect'].value === 'Between' &&
            !isNilOrEmpty(this.printModalForm.controls['transactionDate'].value) &&
            !isNilOrEmpty(this.printModalForm.controls['transactionToDate'].value) &&
            this.fromDate > this.toDate
        ) {
            this.transactionDatePickerTemplate.updateCustomValidation(
                'set',
                this.customFilterLabels.TRANSACTION_DATE_TYPE_ERROR_MSG.DATE_RANGE
            );
            this.transactionToDatePickerTemplate.updateCustomValidation('set', '');
        } else if (
            this.printModalForm.controls['transactionDateSelect'].value === 'Between' &&
            !isNilOrEmpty(this.printModalForm.controls['transactionDate'].value) &&
            !isNilOrEmpty(this.printModalForm.controls['transactionToDate'].value) &&
            this.fromDate <= this.toDate
        ) {
            this.transactionDatePickerTemplate.updateCustomValidation('remove');
            this.transactionToDatePickerTemplate.updateCustomValidation('remove');
        }
    }

    compareClaimNotesDates() {
        if (
            this.printModalForm.controls['noteDateSelect'].value === 'Between' &&
            !isNilOrEmpty(this.printModalForm.controls['noteDate'].value) &&
            !isNilOrEmpty(this.printModalForm.controls['noteToDate'].value) &&
            this.fromDate > this.toDate
        ) {
            this.ClaimNotesDatePickerTemplate.updateCustomValidation(
                'set',
                this.customFilterLabels.TRANSACTION_DATE_TYPE_ERROR_MSG.DATE_RANGE
            );
            this.ClaimNotesToDatePickerTemplate.updateCustomValidation('set', '');
        } else if (
            this.printModalForm.controls['noteDateSelect'].value === 'Between' &&
            !isNilOrEmpty(this.printModalForm.controls['noteDate'].value) &&
            !isNilOrEmpty(this.printModalForm.controls['noteToDate'].value) &&
            this.fromDate <= this.toDate
        ) {
            this.ClaimNotesDatePickerTemplate.updateCustomValidation('remove');
            this.ClaimNotesToDatePickerTemplate.updateCustomValidation('remove');
        }
    }

    transactionDateChangeHandler(event: any, dropdown, input, field = '') {
        this.datepickerOne.setError(null);
        this.datepickerOne.setMessage('');
        this.datepickerTwo?.setError(null);
        this.datepickerTwo?.setMessage('');
        if (field === '') {
            this.selectedDate = event.detail.valueAsDate;

            const formattedDate = moment(this.selectedDate).utc().format('YYYY-MM-DD');

            this.printModalForm.get('transactionDate')?.setValue(formattedDate);
        } else {
            this.selectedEndDate = event.detail.valueAsDate;
            const formattedDate = moment(this.selectedEndDate).utc().format('YYYY-MM-DD');
            this.printModalForm.get('transactionToDate')?.setValue(formattedDate);
        }
        dropdown.clearValidators();
        dropdown.updateValueAndValidity();
        dropdown.markAsUntouched();
        dropdown.setErrors(null);
        if (this.selectedDate) {
            if (!dropdown.value || dropdown.value == '(Blank)') {
                dropdown.setValidators(Validators.required);
                dropdown.updateValueAndValidity();
                dropdown.setErrors({ required: true });
                dropdown.markAsTouched();
            }
        }
        this.checkTransactionDateValidations();
    }

    claimNotesDateChangeHandler(event: any, dropdown, input, field = '') {
        this.datepickerThree.setError(null);
        this.datepickerThree.setMessage('');
        this.datepickerFour?.setError(null);
        this.datepickerFour?.setMessage('');
        if (field === '') {
            this.selectedDate = event.detail.valueAsDate;
            const formattedDate = moment(this.selectedDate).utc().format('YYYY-MM-DD');
            this.printModalForm.get('noteDate')?.setValue(formattedDate);
        } else {
            this.selectedEndDate = event.detail.valueAsDate;
            const formattedDate = moment(this.selectedEndDate).utc().format('YYYY-MM-DD');
            this.printModalForm.get('noteToDate')?.setValue(formattedDate);
        }
        dropdown.clearValidators();
        dropdown.updateValueAndValidity();
        dropdown.markAsUntouched();
        dropdown.setErrors(null);
        if (this.selectedDate) {
            if (!dropdown.value || dropdown.value == '(Blank)') {
                dropdown.setValidators(Validators.required);
                dropdown.updateValueAndValidity();
                dropdown.setErrors({ required: true });
                dropdown.markAsTouched();
            }
        }

        this.checkClaimNotesDateValidation();
    }

    checkTransactionDateValidations() {
        let valid = true;
        this.datepickerTwo?.setError(null);
        this.datepickerTwo?.setMessage('');
        this.datepickerOne?.setError(null);
        this.datepickerOne?.setMessage('');
        if (
            this.printModalForm.controls['transactionDateSelect'].value === 'Between' &&
            !this.selectedEndDate &&
            !this.selectedDate
        ) {
            valid = false;
            this.datepickerOne.setError({ message: '' });
            this.datepickerTwo.setError({ message: 'Two values are required.' });
        } else if (this.printModalForm.controls['transactionDateSelect'].value === 'Between' && !this.selectedDate) {
            valid = false;
            this.datepickerOne.setError({ message: 'You must enter a From Date.' });
        } else if (this.printModalForm.controls['transactionDateSelect'].value === 'Between' && !this.selectedEndDate) {
            valid = false;
            this.datepickerTwo.setError({ message: 'You must enter a To Date.' });
        } else if (this.printModalForm.controls['transactionDateSelect'].value && !this.selectedDate) {
            valid = false;
            this.datepickerOne.setError({ message: 'A date must be entered.' });
        } else if (this.selectedDate && !this.printModalForm.controls['transactionDateSelect'].value) {
            valid = false;
            this.printModalForm.controls['transactionDateSelect'].setErrors({ required: true });
        } else if (this.datepickerTwo && this.selectedDate > this.selectedEndDate) {
            this.datepickerTwo?.setError({ message: 'To date must be greater than From date.' });
            valid = false;
        }
        return valid;
    }

    checkClaimNotesDateValidation() {
        let valid = true;
        this.datepickerFour?.setError(null);
        this.datepickerFour?.setMessage('');
        this.datepickerThree?.setError(null);
        this.datepickerThree?.setMessage('');
        if (
            this.printModalForm.controls['noteDateSelect'].value === 'Between' &&
            !this.selectedEndDate &&
            !this.selectedDate
        ) {
            valid = false;
            this.datepickerThree.setError({ message: '' });
            this.datepickerFour.setError({ message: 'Two values are required.' });
        } else if (this.printModalForm.controls['noteDateSelect'].value === 'Between' && !this.selectedDate) {
            valid = false;
            this.datepickerThree.setError({ message: 'You must enter a From Date.' });
        } else if (this.printModalForm.controls['noteDateSelect'].value === 'Between' && !this.selectedEndDate) {
            valid = false;
            this.datepickerFour.setError({ message: 'You must enter a To Date.' });
        } else if (this.printModalForm.controls['noteDateSelect'].value && !this.selectedDate) {
            valid = false;
            this.datepickerThree.setError({ message: 'A date must be entered.' });
        } else if (this.selectedDate && !this.printModalForm.controls['noteDateSelect'].value) {
            valid = false;
            this.printModalForm.controls['noteDateSelect'].setErrors({ required: true });
        } else if (this.datepickerFour && this.selectedDate > this.selectedEndDate) {
            this.datepickerFour?.setError({ message: 'To date must be greater than From date.' });
            valid = false;
        }
        return valid;
    }

    changeInputFinance(event: any, field: string) {
        const selectControl = this.printModalForm.controls['transactionAmountSelect'];
        const startFieldControl = this.printModalForm.controls['transactionAmtField'];
        const endFieldControl = this.printModalForm.controls['transactionAmtEndField'];

        const isBetween = selectControl.value === 'Between';
        const startValue = startFieldControl.value;
        const endValue = endFieldControl.value;

        if (isBetween) {
            const missingStart = !startValue;
            const missingEnd = !endValue;

            this.showBothAmountError = missingStart || missingEnd;

            startFieldControl.setErrors(missingStart ? { required: true } : null);
            endFieldControl.setErrors(missingEnd ? { required: true } : null);
        } else if (!selectControl.value && startValue) {
            this.showOperatorError = true;
            this.showBothAmountError = false;
        } else {
            this.showOperatorError = false;
            this.showBothAmountError = false;
            startFieldControl.setErrors(null);
            endFieldControl.setErrors(null);
        }
    }

    changeInputEndFinance(event: any, field: string) {
        const selectControl = this.printModalForm.controls['transactionAmountSelect'];
        const startFieldControl = this.printModalForm.controls['transactionAmtField'];
        const endFieldControl = this.printModalForm.controls[field];

        const isBetween = selectControl.value === 'Between';
        const startValue = startFieldControl.value;
        const endValue = endFieldControl.value;

        if (isBetween) {
            const missingStart = !startValue;
            const missingEnd = !endValue;

            this.showBothAmountError = missingStart || missingEnd;

            startFieldControl.setErrors(missingStart ? { required: true } : null);
            endFieldControl.setErrors(missingEnd ? { required: true } : null);
        } else {
            this.showBothAmountError = false;
            endFieldControl.setErrors(null);
        }
    }

    handleBetweenAmountType(event: any): void {
        const selectedValue = event.target.value as string;
        this.showFinal = selectedValue.includes('Between');

        if (selectedValue !== '') {
            this.showOperatorError = false;
        }
    }

    showModal(response) {
        this.claimListLength = response;
        if (this.claimListLength > 50) {
            this.printModalForm.disable();
            this.showPrintError = true;
            this.printError = PRINT_ERROR;
        } else {
            this.printModalForm.enable();
            this.showPrintError = false;
            if (this.showCustomData) {
                this.printModalForm.controls['customDemoCheck']?.enable();
            }
            else {
                this.printModalForm.controls['customDemoCheck']?.disable();
            }

        }
        this.printModalRef.show();
        this.printModalForm.controls['financialTransRadio'].disable();
        this.printModalForm.controls['financialValuationDate'].disable();
        this.printModalForm.controls['claimNotesRadio'].disable();
    }

    hideModal() {
        const defaultFormValues = {
            claimDemographicsCheck: false,
            customDemoCheck: false,
            financialMatrixCheck: false,
            financialValuationDate: '',
            financialTransactionsCheck: false,
            financialTransRadio: '',
            claimNotesCheck: false,
            claimNotesRadio: '',
            transactionDateSelect: '',
            transactionDate: '',
            transactionToDate: '',
            transactionAmountSelect: '',
            transactionAmtField: '',
            transactionAmtEndField: '',
            financialCategories: '',
            finacialActivityType: '',
            noteDateSelect: '',
            noteDate: '',
            noteToDate: ''
        };
        this.printModalForm?.reset(defaultFormValues);
        this.printModalForm.controls['claimNotesRadio'].disable();
        this.printModalForm.controls['financialTransRadio'].disable();
        this.isRefineSectionVisible = false;
        this.claimNotesDisableFlag = true
        this.financialTransFlag = true;
        this.isNoteDataVisible = false
        this.showTransactionToDatePicker = false;
        this.showClaimNotesDatePicker = false;
        this.showFinal = false;
        this.showBothAmountError = false;
        this.showOperatorError = false;
        this.printModalRef?.hide();
    }

    atLeastOneFieldFilled(): boolean {
        const formValue = this.printModalForm.value;

        const checkboxes = [
            formValue.claimDemographicsCheck,
            formValue.customDemoCheck,
            formValue.financialMatrixCheck,
            formValue.financialTransactionsCheck,
            formValue.claimNotesCheck
        ];

        const isAnyCheckboxChecked = checkboxes.some((val) => val === true);

        return isAnyCheckboxChecked;
    }

    hasInvalidDateOrAmountCriteria(): boolean {
        const form = this.printModalForm.value;

        const dateSelected = form.transactionDate;
        const dateOperator = form.transactionDateSelect;
        const toDate = form.transactionToDate;

        if ((dateSelected && !dateOperator) || (dateOperator === 'Between' && (!dateSelected || !toDate))) {
            return true;
        }

        const amountSelected = form.transactionAmtField;
        const amountOperator = form.transactionAmountSelect;
        const amountEnd = form.transactionAmtEndField;

        if ((amountSelected && !amountOperator) || (amountOperator === 'Between' && (!amountSelected || !amountEnd))) {
            return true;
        }

        const noteDate = form.noteDate;
        const noteOperator = form.noteDateSelect;
        const noteToDate = form.noteToDate;

        if ((noteDate && !noteOperator) || (noteOperator === 'Between' && (!noteDate || !noteToDate))) {
            return true;
        }

        return false;
    }

    savePrintDetails() {
        if (!this.atLeastOneFieldFilled()) {
            this.printError = PRINT_ERROR_MESSAGE;
            this.showPrintError = true;
            return;
        }
        if (this.hasInvalidDateOrAmountCriteria()) {
            return;
        }

        this.showPrintError = false;
        const printCriteria = this.buildPrintClaimDetailsCriteria();
        this.printClicked.emit(printCriteria);
        setTimeout(() => {
            this.hideModal()
        }, 200)
    }

    checkboxCheck(event) {
        if (event.target.checked) {
            this.showPrintError = false;
        }
    }

    buildPrintClaimDetailsCriteria(): any {
        const formVal = this.printModalForm.value;

        return {
            claimDemographics: formVal.claimDemographicsCheck,
            customData: formVal.customDemoCheck,
            financialMatrix: formVal.financialMatrixCheck,
            valuationDate: formVal.financialValuationDate || null,
            financialTransactions: formVal.financialTransactionsCheck,
            transactionSelection: formVal.financialTransRadio || null,
            transactionFromDate: formVal.transactionDate || null,
            transactionToDate: formVal.transactionToDate || null,
            transactionDateOperator: formVal.transactionDateSelect || null,
            transactionFromAmount: formVal.transactionAmtField || null,
            transactionToAmount: formVal.transactionAmtEndField || null,
            transactionAmountOperator: formVal.transactionAmountSelect || null,
            listFinancialCategories: formVal.financialCategories || null,
            financialActivityType: formVal.finacialActivityType || null,
            claimNotes: formVal.claimNotesCheck,
            claimNoteSelection: formVal.claimNotesRadio || null,
            claimNoteDateOperator: formVal.noteDateSelect || null,
            claimNoteFromDate: formVal.noteDate || null,
            claimNoteToDate: formVal.noteToDate || null
        };
    }

    loadDropdownData(): void {
        this.claimService.getFinancialDropdownData().subscribe({
            next: (data) => {
                this.finacialCategories = data.financialCategories.map((item: any) => ({
                    value: item.value,
                    label: item.label
                }));

                this.activityTypes = [
                    { value: '', label: 'Select' },
                    ...data.financialActivityTypes.map((item: any) => ({
                        value: item.label,
                        label: item.label
                    }))
                ];
            },
            error: (err) => { }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
